export default __webpack_public_path__ + "static/sean-pollock-ph-yq-704-ffd-a-unsplash-e0fbcd8428949b9770c976bbe0116b92.png";